"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SankeyLayout = require("./SankeyLayout");

var _types = require("./types");

var _SankeyUtils = require("./SankeyUtils");

var SankeyNodeContextMenuPropTypes = {
  data: _propTypes.default.shape(_types.SankeyDataPropTypes).isRequired,
  set_data: _propTypes.default.func.isRequired,
  closeNodeContextMenu: _propTypes.default.func.isRequired,
  selected_node: _propTypes.default.shape(_types.SankeyNodePropTypes).isRequired,
  show: _propTypes.default.bool.isRequired
};

var SankeyNodeContextMenu = function SankeyNodeContextMenu(_ref) {
  var data = _ref.data,
      set_data = _ref.set_data,
      show = _ref.show,
      selected_node = _ref.selected_node,
      closeNodeContextMenu = _ref.closeNodeContextMenu;
  var display_nodes = data.nodes;
  var display_links = data.links;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, {
    size: "sm",
    show: show,
    onHide: closeNodeContextMenu
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    closeButton: true
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.ButtonGroup, {
    style: {
      'marginLeft': '10px'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    style: {
      'marginBottom': '3px',
      'marginRight': '3px'
    },
    onClick: function onClick() {
      (0, _SankeyLayout.reorganize_inputLinksId)(selected_node, true, false, display_nodes, display_links);
      closeNodeContextMenu();
    }
  }, "R\xE9organiser liens entrants"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    style: {
      'marginBottom': '3px'
    },
    onClick: function onClick() {
      (0, _SankeyLayout.reorganize_inputLinksId)(selected_node, false, true, display_nodes, display_links);
      closeNodeContextMenu();
    }
  }, "R\xE9organiser liens sortants")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.ButtonGroup, {
    style: {
      'marginLeft': '10px'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    style: {
      'marginBottom': '3px'
    },
    onClick: function onClick() {
      (0, _SankeyUtils.delete_node)(data, selected_node);
      set_data((0, _objectSpread2.default)({}, data));
      closeNodeContextMenu();
    }
  }, "Supprimer noeud")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.ButtonGroup, {
    style: {
      'marginLeft': '10px'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    style: {
      'marginBottom': '3px',
      'marginRight': '3px'
    },
    onClick: function onClick() {
      while (selected_node.inputLinksId.length > 0) {
        var link = display_links[selected_node.inputLinksId[0]];
        (0, _SankeyUtils.delete_link)(data, link);
      }

      set_data((0, _objectSpread2.default)({}, data));
    }
  }, "Supprimer flux entrant"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    style: {
      'marginBottom': '3px'
    },
    onClick: function onClick() {
      while (selected_node.outputLinksId.length > 0) {
        var link = display_links[selected_node.outputLinksId[0]];
        (0, _SankeyUtils.delete_link)(data, link);
      }

      set_data((0, _objectSpread2.default)({}, data));
    }
  }, "Supprimer flux sortant")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.ButtonGroup, {
    style: {
      'marginLeft': '10px'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    style: {
      'marginBottom': '3px',
      'marginRight': '3px'
    },
    onClick: function onClick() {
      var current_x = selected_node.x;
      var current_prev_y = selected_node.y - data.v_space;
      var node_to_replace = Object.values(display_nodes).filter(function (n) {
        return n.node_visible && n.x === current_x && n.y === current_prev_y;
      })[0];

      if (node_to_replace !== undefined) {
        node_to_replace.y = selected_node.y;
      }

      selected_node.y = selected_node.y - data.v_space;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }, "Monter"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    style: {
      'marginBottom': '3px',
      'marginRight': '3px'
    },
    onClick: function onClick() {
      var current_x = selected_node.x;
      var current_prev_y = selected_node.y + data.v_space;
      var node_to_replace = Object.values(display_nodes).filter(function (n) {
        return n.node_visible && n.x === current_x && n.y === current_prev_y;
      })[0];

      if (node_to_replace !== undefined) {
        node_to_replace.y = selected_node.y;
      }

      selected_node.y = selected_node.y + data.v_space;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }, "Descendre")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.ButtonGroup, {
    style: {
      'marginLeft': '10px'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    style: {
      'marginBottom': '3px'
    },
    onClick: function onClick() {
      var current_prev_x = Math.round(selected_node.x / data.h_space) * data.h_space - data.h_space;
      var current_y = selected_node.y;
      var node_to_replace = Object.values(display_nodes).filter(function (n) {
        return n.node_visible && n.x === current_prev_x && n.y === current_y;
      })[0];

      if (node_to_replace !== undefined) {
        node_to_replace.x = Math.round(selected_node.x / data.h_space) * data.h_space;
      }

      selected_node.x = current_prev_x;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }, "D\xE9caler gauche"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    style: {
      'marginBottom': '3px'
    },
    onClick: function onClick() {
      var current_prev_x = Math.round(selected_node.x / data.h_space) * data.h_space + data.h_space;
      var current_y = selected_node.y;
      var node_to_replace = Object.values(display_nodes).filter(function (n) {
        return n.node_visible && n.x === current_prev_x && n.y === current_y;
      })[0];

      if (node_to_replace !== undefined) {
        node_to_replace.x = Math.round(selected_node.x / data.h_space) * data.h_space;
      }

      selected_node.x = current_prev_x;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }, "D\xE9caler droite"))));
};

var _default = SankeyNodeContextMenu;
exports.default = _default;